import React from 'react';
import '../../scss/workoffice.scss';
import { WorkOfficeApp } from './Functionality/WorkOfficeApp';
import LiveClockAndDate from './Subcomponents/LiveClockAndDate';
import StatusCard from './Subcomponents/StatusCard';
import WelcomeComponent from './Subcomponents/WelcomeComponent';
import FullPageLoader from '../../utils/FullPageLoader';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const WorkOffice = () => {
    const {
        checkInFn,
        checkOutFn,
        getWorkOffice,
        t,
        status,
        totalHours,
        hours,
        minutes,
        currentAction,
        actionHandlers,
        showSpinner,
        disabled,
    } = WorkOfficeApp();

    return (
        <>
            {showSpinner && <FullPageLoader />}
            <div className='work-office-background background-radial-gradient-primary-50 border-radius-16px position-relative overflow-hidden'>
                <div className='position-absolute top-0 start-0 w-100 p-3'>
                    <div className='row align-items-center px-3 gy-3'>
                        <div className='col-12 col-md-6'>
                            <LiveClockAndDate />
                        </div>
                        <div className='col-12 col-md-6 d-flex justify-content-md-end'>
                            <StatusCard t={t} status={status} />
                        </div>
                    </div>
                </div>

              <div className='work-office-content'>
                    <WelcomeComponent
                        t={t}
                        totalHours={totalHours}
                        getWorkOffice={getWorkOffice}
                        status={status}
                        checkInFn={checkInFn}
                        checkOutFn={checkOutFn}
                        hours={hours}
                        minutes={minutes}
                        currentAction={currentAction}
                        actionHandlers={actionHandlers}
                        disabled={disabled}
                    />
                </div>
            </div>
        </>
    );
};

export default WorkOffice;
